import React, { Component, ReactNode } from 'react';

interface ErrorBoundaryProps {
  fallback: ({ error }: { error: Error }) => JSX.Element;
  children: ReactNode;
}

interface ErrorBoundaryState {
  error: Error | null;
}

/**
 * This ErrorBoundary is created as a part of our migration from Sentry to APMS
 */
class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = {
      error: null,
    };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    // Update state so that the next render will show the fallback UI.
    // TODO @tranct migrate to getDerivedStateFromError(error) when we switch to React 18
    // https://react.dev/reference/react/Component#catching-rendering-errors-with-an-error-boundary
    this.setState({
      error,
    });

    // Optionally log the error and info to an external service
    console.error('ErrorBoundary caught an error', error, info);

    // TODO @tranct report the error to APMS
  }

  render() {
    const { error } = this.state;
    const { fallback, children } = this.props;

    if (error) {
      return fallback({ error: error! });
    }

    return children;
  }
}
export default ErrorBoundary;
